import { render, staticRenderFns } from "./visitor-blacklist.vue?vue&type=template&id=2ec2dcc9&"
import script from "./visitor-blacklist.vue?vue&type=script&lang=js&"
export * from "./visitor-blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports